module.exports = __webpack_public_path__ + "static/card6-f2c8c295cad2de8d01c45e795c685776.png";